<app-top-nav></app-top-nav>

<div class="main">
  <div class="wrapper">
    <div class="global-head-column">
      <div class="global-head-row">
        <app-area-selector
          class="vertical-flex"
          (blockUpdated)="onUpdateAreaId($event)"
        ></app-area-selector>

        <div class="searchBar">
          <input
            type="text"
            pInputText
            size="20"
            placeholder="Global Filter"
            [(ngModel)]="globalFilter"
          />
          <button
            class="AZ-button"
            disabled
            mat-stroked-button
            color="secundary"
          >
            <mat-icon class="searchIcon">search</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="scroll-wrapper">
      <!--<span>Select a city, FH and Block to start.</span>-->
      <p-table
        #dt
        [columns]="cols"
        selectionMode="single"
        [value]="tableData$() | async"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [class.col--building-group]="col.field == 'buildingGroupId'"
              [class.col--address]="col.field == 'address'"
              [class.col--keys]="col.field == 'buildingLomKey'"
              [class.col--nr]="col.field == 'number'"
              [class.col--button]="
                ['tsa', 'ssr', 'remarks'].includes(col.field)
              "
              [class.col--survey-info]="['surveyInfo'].includes(col.field)"
              [class.col--info]="['tsaInfo', 'snsInfo'].includes(col.field)"
              [class.col--type]="['tsaType'].includes(col.field)"
            >
              <div class="status-flex">
                <div
                  class="horizontal-flex"
                  *ngIf="!checkSortIcon(col.field); else filterHeader"
                >
                  {{ col.header }}
                </div>
                <ng-template #filterHeader>
                  <div
                    class="horizontal-flex clickable"
                    [matMenuTriggerFor]="extendedFilter"
                    #menuTrigger="matMenuTrigger"
                  >
                    {{ col.header }}
                    <ng-container
                      *ngIf="{
                        direction: (getFieldSort$(col.field) | async)
                      } as sort"
                    >
                      <mat-icon
                        class="sortIcon {{
                          sort.direction == 1
                            ? 'sort-ascending'
                            : 'sort-descending'
                        }}"
                        *ngIf="sort.direction"
                        >straight</mat-icon
                      >
                    </ng-container>
                    <mat-icon class="material-icons-outlined sortIcon"
                      >filter_alt</mat-icon
                    >
                    <ng-container
                      *ngIf="getFieldFilters$(col.field) | async as filters"
                    >
                      <span *ngIf="filters" class="clear-header-filters"
                        >({{ filters.length }})</span
                      >
                    </ng-container>
                  </div>
                  <mat-menu
                    class="column-filter-menu"
                    #extendedFilter="matMenu"
                    [hasBackdrop]="true"
                  >
                    <app-column-filter
                      *ngIf="menuTrigger.menuOpen"
                      [values]="getFieldValues$(col.field) | async"
                      [template]="getFieldTemplate(col.field)"
                      [canSearch]="getFieldFilterSearch(col.field)"
                      [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                      [initialSelected]="getFieldFilters$(col.field) | async"
                      [initialSort]="getFieldSort$(col.field) | async"
                      [ignoredValues]="col.ignoredFilterValues"
                      (sort)="setSort(col.field, $event)"
                      (filter)="setFilter(col.field, $event)"
                      (closePopup)="menuTrigger.closeMenu()"
                    ></app-column-filter>
                  </mat-menu>
                </ng-template>
                <ng-container *ngIf="col.field == 'remarks'">
                  <button
                    class="clear-button"
                    mat-flat-button
                    color="warn"
                    (click)="clearAllFilter()"
                    *ngIf="extendedFilterActive$ | async"
                  >
                    clear all
                  </button>
                </ng-container>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
          <tr>
            <td class="col--building-group">
              <ng-container
                *ngTemplateOutlet="
                  buildingGroup;
                  context: { data: item.figure }
                "
              ></ng-container>
            </td>
            <td class="col--keys">
              <div class="vertical-flex">
                <span class="bold">B-{{ item.buildingLomKey }}</span>
                <span>A-{{ item.addressLomKey }}</span>
              </div>
            </td>
            <td class="col--address">
              <div class="vertical-flex">
                <span>{{ item.street }}</span>
                <span>{{ item.postalCode }} {{ item.city }}</span>
              </div>
            </td>
            <td class="col--nr">
              <div class="vertical-flex center">
                <span>{{ item.number }}</span>
                <span>{{ item.suffix }}</span>
              </div>
            </td>
            <td class="col--survey-info">
              <div class="vertical-flex">
                <span>{{ buildingType[item.buildingType] }}</span>
                <span>{{ surveyStatus[item.status] }}</span>
                <span>Quadrant: {{ quadrant[item.quadrant] }}</span>
                <span>Units: {{ item.totalUnits }}</span>
              </div>
            </td>
            <td class="col--button">
              <div class="chipBtns">
                <button
                  *ngFor="let docLang of docLanguages"
                  class="chip clickable"
                  [ngClass]="docLang.class"
                  mat-stroked-button
                  [disabled]="!canTogglePrintState(item)"
                  (click)="
                    openPreviewScreen(docLang.language, docType.TSA, item)
                  "
                >
                  {{ docLang.label }}
                </button>
                <button
                  *ngIf="
                    item.status === surveyStatus.InsideDone &&
                    item.canBeDeleted &&
                    this.canWrite
                  "
                  [disabled]="item.status != surveyStatus.InsideDone"
                  pTooltip="Delete TSA"
                  class="chip remark"
                  [class.red-background]="item.canBeDeleted"
                  (click)="onDeleteClick(item)"
                  mat-stroked-button
                >
                  <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
              </div>
            </td>
            <td class="col--info">
              <div
                class="vertical-flex"
                [class.disabled]="item.status != surveyStatus.InsideDone"
              >
                <span>Sent: {{ formatDate(item.tsaSentDate) }}</span>
                <span>Exp. Fb.: {{ formatDate(item.expectedFeedback) }}</span>
                <span
                  >Approval:
                  <a
                    *ngIf="this.canWrite && item.canBeApproved"
                    (click)="openApprovalScreen(item)"
                    i18n="@@document.list.approval.waiting"
                    >Waiting for Approval</a
                  >
                  <div
                    *ngIf="this.canWrite && item.canUploadTSA"
                    class="action-buttons"
                  >
                    <button class="upload-button" (click)="onUploadClick(item)">
                      <div></div>
                    </button>
                    <input
                      #uploadInput
                      [id]="tableCellUploadId(item)"
                      type="file"
                      (change)="onUploadFile($event, item)"
                    />
                    <button
                      class="reject-button"
                      (click)="onOwnerRejectClick(item)"
                    >
                      <div></div>
                    </button>
                  </div>
                  <a
                    *ngIf="item.rejected"
                    (click)="onShowRejectedPreview(item)"
                    i18n="@@document.list.approval.rejected"
                    >Rejected</a
                  >
                  <a
                    *ngIf="item.signedButRejected"
                    (click)="onSignedPreview(item)"
                    i18n="@@document.list.approval.tsa.notapproved"
                    >Signed TSA not approved</a
                  >
                  <a *ngIf="item.approved" (click)="onSignedPreview(item)">{{
                    formatDate(item.approvedDate)
                  }}</a>
                </span>
              </div>
            </td>
            <!---->
            <td class="col--type">
              <div class="vertical-flex">
                <span>
                  <div style="float: left">
                    <p-checkbox
                      #cb
                      [(ngModel)]="item.tsaType == tsaType.NoTsa || item.noTSA"
                      binary="true"
                      name="checked"
                      [disabled]="!canToggleNoTsaState(item)"
                      (onChange)="toggleNoTSA(item)"
                    ></p-checkbox>
                    <span> No Tsa </span>
                  </div>
                  <div style="float: right">
                    <p-tooltip
                      class="circle"
                      style="padding-top: 8px; padding-right: 10px"
                      [fitContent]="true"
                      [escape]="false"
                      pTooltip="Use if TSA isn’t required<br/> (ex. Quadrant D without BDFO)"
                    >
                      <mat-icon class="material-icons-outlined">info</mat-icon>
                    </p-tooltip>
                  </div>
                </span>
                <span>
                  <div style="float: left">
                    <p-checkbox
                      #cb
                      [(ngModel)]="
                        item.tsaType == tsaType.NoAdmin || item.noAdminTSA
                      "
                      binary="true"
                      name="checked"
                      [disabled]="!canToggleNoAdminState(item)"
                      (onChange)="toggleNoAdminTSA(item)"
                    ></p-checkbox>
                    <span> No Admin </span>
                  </div>
                  <div style="float: right">
                    <p-tooltip
                      class="circle"
                      style="padding-top: 8px; padding-right: 10px"
                      pTooltip="Use as the best default option"
                    >
                      <mat-icon class="material-icons-outlined">info</mat-icon>
                    </p-tooltip>
                  </div>
                </span>
                <span>
                  <div style="float: left">
                    <p-checkbox
                      #cb
                      [(ngModel)]="item.tsaType == tsaType.Normal || item.tsa"
                      binary="true"
                      name="checked"
                      [disabled]="!canToggleTsaState(item)"
                      (onChange)="toggleTSA(item)"
                    ></p-checkbox>
                    <span> Tsa </span>
                  </div>
                  <div style="float: right">
                    <p-tooltip
                      class="circle"
                      style="padding-top: 8px; padding-right: 10px"
                      [fitContent]="true"
                      [escape]="false"
                      tooltipStyleClass="tooltip"
                      pTooltip="Only use if:<br/> •The technical solution will be very<br/> complex and outside of the usual<br/> proposals<br/> •There are aesthetic reasons that <br/>could complicate the current proposal<br/> of a technical solution.<br/> •There Will Be A Heavy Impact On<br/> The Habitants Of The Lu’s (Large<br/> Construction Works Etc.)"
                    >
                      <mat-icon class="material-icons-outlined">info</mat-icon>
                    </p-tooltip>
                  </div>
                </span>
              </div>
            </td>
            <!---->
            <td class="col--button">
              <div class="chipBtns">
                <button
                  *ngFor="let docLang of docLanguages"
                  class="chip clickable"
                  [ngClass]="docLang.class"
                  mat-stroked-button
                  [disabled]="item.status != surveyStatus.InsideDone"
                  (click)="
                    openPreviewScreen(docLang.language, docType.SSR, item)
                  "
                >
                  {{ docLang.label }}
                </button>
              </div>
            </td>
            <td class="col--info">
              <div class="vertical-flex">
                <span>TSA: {{ snsRecordStatus[item.tsaSnsUploadStatus] }}</span>
                <span>{{ formatDate(item.tsaSnsUploadTime) }}</span>
                <span>SSR: {{ snsRecordStatus[item.ssrSnsUploadStatus] }}</span>
                <span>{{ formatDate(item.ssrSnsUploadTime) }}</span>
              </div>
            </td>
            <td class="col--button">
              <div class="chipBtns">
                <button
                  class="chip remark"
                  [class.blue-background]="!!item.generalRemarks"
                  (click)="onGeneralRemarksClick(item)"
                  mat-stroked-button
                >
                  <mat-icon class="material-icons-outlined">sms</mat-icon>
                </button>
                <button
                  *ngIf="hasRejectionRemarks(item)"
                  class="chip remark red-background"
                  (click)="onRejectionRemarksClick(item)"
                  mat-stroked-button
                >
                  <mat-icon class="material-icons-outlined">sms</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<app-document-preview
  *ngIf="validationScreenVisible"
  [documentListValidationItem]="selectedValidationObject"
  (print)="onPrint($event)"
  (closeDocumentPreview)="closeValidationScreen()"
></app-document-preview>
<app-signed-document-approval
  *ngIf="approvalScreenVisible"
  [item]="selectedApprovalObject"
  (back)="closeApprovalScreen()"
  (validate)="onSignedValidate($event)"
  (reject)="onSignedReject($event)"
>
</app-signed-document-approval>
<app-signed-document-preview
  *ngIf="signedApprovalScreenVisible"
  [item]="selectedApprovalObject"
  (closeSignedDocumentPreview)="onSignedClose()"
  (uploadNew)="onSelectedUploadClick()"
  (backToPending)="onBackToPending()"
>
</app-signed-document-preview>
<input
  #uploadInput
  [id]="selectedItemId()"
  type="file"
  (change)="onSelectedUploadFile($event)"
/>

<app-rejected-document-preview
  *ngIf="rejectedPreviewVisible"
  [item]="selectedApprovalObject"
  (closeRejectedDocumentPreview)="onRejectedPreviewClose()"
  (uploadNew)="onSelectedUploadClick()"
  (backToPending)="onBackToPendingFull()"
>
</app-rejected-document-preview>

<!-- TEMPLATES -->
<ng-template #buildingGroup let-data="data">
  <app-figure
    [Color]="data?.Color"
    [Figure]="data?.Figure"
    style="margin: 0 !important"
  ></app-figure>
</ng-template>
